import React from 'react';

/**
 * DataContext — provides project data, tokens, scripts, and edition state.
 *
 * Available to all components via <DataContext.Consumer> or static contextType.
 */
const DataContext = React.createContext({
  // Projects
  projects: [],
  projectId: null,
  projectIdToArtistAddress: [],
  projectArtistAddress: null,
  projectTokens: [],
  projectCurrentEditions: null,
  projectIsSoldOut: false,

  // Pricing
  projectPricePerEditionInWei: null,
  projectPricePerEditionInEth: null,
  projectAdditionalPayee: null,
  projectAdditionalPayeePercent: null,
  projectRoyaltyAddress: null,
  royaltyContractBalance: null,

  // Script
  script: null,
  warnScriptPosterArtistMismatch: false,
  warnScriptPageProjectNameMismatch: false,

  // Images / IPFS
  projectIdToImageURLBase: null,
  projectIdToImageURLExt: null,
  projectIdUseImageURLInGridView: null,
  clientViewImageURLInDetailView: false,
  ipfsUnavailable: false,

  // Selected edition
  tokenId: null,
  editionId: null,
  ownerOfSelectedEdition: null,
  editionIdEventHistoryData: null,
  editionIdMetadata: null,
  metadataObject: null,

  // Pagination
  currentPage: 1,

  // Platform config and contract state
  platform: {},
  contract: null,
  artistPercent: 0,
  secondaryRoyaltyPercent: 0,
  featuredProjectId: null,
  projectFeeInEth: null,

  // Curator / Beneficiary
  curator: null,
  curatorPercent: null,
  beneficiary: null,
  beneficiaryPercent: null,
  contractBalance: 0,

  // Loading
  loading: true,
  loadingDescription: "",
});

DataContext.displayName = 'DataContext';

export default DataContext;
